var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
let TextField = class TextField extends Vue {
    constructor() {
        super(...arguments);
        this.focus = false;
    }
    get classes() {
        return {
            'text-field--active': this.focus,
            'text-field--disabled': this.disabled,
            'text-field--error': this.error
        };
    }
    render(h) {
        const data = {
            staticClass: 'text-field',
            class: this.classes,
            attrs: {
                type: this.type,
                placeholder: this.placeholder,
                disabled: this.disabled,
            },
            domProps: {
                value: this.value
            },
            on: {
                input: (e) => this.$emit('input', e.target.value),
                focus: (e) => {
                    this.focus = true;
                    this.$emit('focus', e);
                },
                blur: (e) => {
                    this.focus = false;
                    this.$emit('blur', e);
                },
                keydown: (e) => {
                    if (e.keyCode === 13) {
                        this.focus = false;
                        this.$emit('enter', e);
                    }
                }
            }
        };
        return h('input', data);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], TextField.prototype, "value", void 0);
__decorate([
    Prop({ default: 'text' }),
    __metadata("design:type", String)
], TextField.prototype, "type", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TextField.prototype, "error", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TextField.prototype, "disabled", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], TextField.prototype, "placeholder", void 0);
TextField = __decorate([
    Component({})
], TextField);
export { TextField };
//# sourceMappingURL=TextField.js.map